module.exports = new __parcel__URL__("pve_button_bg.38275127.png").toString();